// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3PP-a","bigColWidth":"Table_bigColWidth__3AEqe","biggerColWidth":"Table_biggerColWidth__3CfY0","row":"Table_row__29nFw","col":"Table_col__1bJBe"};